import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { RaisedButton } from "material-ui";
import { Table, Tr, Td, Sort } from "reactable";
import { Link } from "react-router";

import VirtualContentTable from "./partials/virtual-content-table.jsx";
import FilmTable from "./partials/film-table.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";
import VirtualContentStore from "../stores/VirtualContentStore";
import VirtualContentActions from "../actions/VirtualContentActions";
import TitleStore from "../stores/TitleStore";
import TitleActions from "../actions/TitleActions";

import config from "../config";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";
import { TitleDeliveryStatus } from "./partials/film-table.jsx";

class Films extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [UserStore, FilmStore, VirtualContentStore, TitleStore];
  }

  static getPropsFromStores() {
    return {
      filmStore: FilmStore.getState(),
      titleStore: TitleStore.getState()
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  componentWillMount() {
    FilmActions.fetchAllForCreator();
    VirtualContentActions.fetchAll();
    TitleActions.fetchAll();
  }

  render() {
    let styles = this.getStyles(),
      titles = values(
        pick(this.props.titleStore.titles, f => {
          return true;
        })
      ),
      films = values(
        pick(this.props.filmStore.films, f => {
          return (
            !!f.event_bucket_name &&
            !(f.virtual_content && f.virtual_content.type !== "vod") &&
            !titles.some(
              t =>
                t.receiving_film &&
                t.receiving_film.id === f.id &&
                t.receiving_film.title_requested_media &&
                !t.receiving_film.title_requested_media.includes("virtual") // hide if title delivery but only for print
            ) &&
            (!UserStore.getUser() || f.owner_id !== UserStore.getUser().id)
          );
        })
      ),
      virtualContent = VirtualContentStore.getVirtualContent().filter(
        v =>
          v.status !== "pending_upload" &&
          v.status !== "vod_upload_started" &&
          v.type === "vod" &&
          v.platform !== "cinesend" && // Deprecated pathway
          v.platform !== "eventive" // Deprecated pathway
      );

    if (
      (films.length === 0 && FilmStore.getState().isFetching) ||
      (virtualContent.length === 0 &&
        VirtualContentStore.getState().isFetching) ||
      (titles.length === 0 && TitleStore.getState().isFetching)
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    const hasTitles = titles.length > 0;

    const hasVirtualContent = virtualContent.length > 0;

    return (
      <div>
        <h1>Eventive Creator Hub</h1>
        <p style={{ fontSize: "12pt" }}>
          Welcome to the Creator Hub. Here you can manage all the content you
          have uploaded to Eventive as well as authorized screenings hosted by
          other organizations.
        </p>
        {hasTitles ? (
          <div className="Eventive--TitlesTable">
            <h2 style={{ marginTop: "1em", marginBottom: "0em" }}>
              Your titles
            </h2>
            <Table
              className="bordered striped responsive-table"
              style={{ margin: "0.5em 0" }}
              columns={[
                "Delivery Identifier",
                "Recipient",
                "Status",
                "Actions"
              ]}
            >
              {titles
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((title, i) => {
                  return [
                    <Tr
                      key={title.id}
                      style={{
                        backgroundColor: "rgb(2, 136, 209)",
                        color: "#fff"
                      }}
                    >
                      <Td
                        column="Delivery Identifier"
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.25em"
                        }}
                      >
                        <div style={{}}>
                          <span style={{ fontFamily: "monospace, sans-serif" }}>
                            {title.delivery_identifier_prefix}
                          </span>{" "}
                          &middot; {title.name}
                        </div>
                      </Td>
                    </Tr>
                  ].concat(
                    title.title_deliveries.length
                      ? title.title_deliveries.map((titleDelivery, i) => {
                          return (
                            <Tr key={titleDelivery.id}>
                              <Td column="Delivery Identifier">
                                <span
                                  style={{
                                    fontFamily: "monospace, sans-serif"
                                  }}
                                >
                                  {titleDelivery.delivery_identifier}
                                </span>
                              </Td>
                              <Td column="Recipient">
                                <span>
                                  {titleDelivery.receiving_event_bucket.name} (
                                  {titleDelivery.receiving_user.organization})
                                </span>
                              </Td>
                              <Td column="Status">
                                <TitleDeliveryStatus
                                  title_delivery={titleDelivery}
                                />
                              </Td>
                              <Td column="Actions">
                                <Link
                                  to={`/titles/${title.id}/deliveries/${titleDelivery.id}`}
                                >
                                  Manage delivery
                                </Link>
                              </Td>
                            </Tr>
                          );
                        })
                      : [
                          <Tr>
                            <Td column="Delivery Identifier">
                              No deliveries, yet
                            </Td>
                          </Tr>
                        ]
                  );
                })}
            </Table>
            <style>{`.Eventive--TitlesTable .reactable-column-header { display: none; }`}</style>
          </div>
        ) : null}
        {hasVirtualContent ? (
          <div>
            <h2 style={{ marginTop: "1em", marginBottom: "0em" }}>
              Uploaded content assets
            </h2>
            <VirtualContentTable virtualContent={virtualContent} />
            <h2 style={{ marginTop: "1em", marginBottom: "0em" }}>
              Screenings
            </h2>
          </div>
        ) : null}
        <FilmTable films={films} creatorView={true} />
      </div>
    );
  }
}

export default connectToStores(Films);



// WEBPACK FOOTER //
// ./src/app/components/creator-hub.jsx